import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * currencyFormat
 */

const currencyFormat = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

/**
 * GenerateEventoColumnsDefinition
 */

type Props = {
  handleActionEdit: (idDependente: number | null) => void,
  handleActionDelete: (idDependente: number) => void,
};

export const GenerateEventoColumnsDefinition = ({
  handleActionEdit,
  handleActionDelete,
}: Props): GridColDef[] => {
  const computeTipoClass = (tipo: number): string => {
    switch (tipo) {
      case 0: return 'bg-[#45b6af] text-white py-[.1rem] px-[.4rem] font-normal';
      case 1: return 'bg-[#f3565d] text-white py-[.1rem] px-[.4rem] font-normal';
      default: return '';
    }
  }

  const computeTipoLabel = (tipo: number): string => {
    switch (tipo) {
      case 0: return 'Acréscimo (+)';
      case 1: return 'Desconto (-)';
      default: return '';
    }
  }

  return [
    {
      field: "nr",
      filterable: false,
      headerName: "Nr",
      width: 120,
      sortable: false,
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      width: 135,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <span className={computeTipoClass(params.value)}>
              {computeTipoLabel(params.value)}
            </span>
          </div>
        );
      },
    },
    {
      field: "item",
      filterable: false,
      headerName: "Item",
      flex: 1,
      minWidth: 80,
      sortable: false,
    },
    {
      field: "valorUnitario",
      filterable: false,
      headerName: "Valor Unit.",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return <div>{currencyFormat.format(params.value)}</div>;
      },
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 80,
      sortable: false,
    },
    {
      field: 'idItemVerbaFuncionario',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 0,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => handleActionEdit(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => handleActionDelete(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      },
    }
  ];
}